module.exports = __webpack_public_path__ + "static/media/091-slovakia.1b0b0b00.svg";